<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup lang="ts">
// 根组件逻辑
</script>

<style scoped>
#app {
  min-height: 100vh;
}
</style> 